export default __webpack_public_path__ + "static/media/yetiskin-icon.56cd08fd.svg";